module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tangeche tangeche-template-amy-or-betty"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "module-title"
  }, [_vm._v("最新车辆")]), _vm._v(" "), _c('div', {
    staticClass: "module-desc"
  }, [_vm._v("新车上架，每天都有新选择")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "module-body"
  }, [_c('div', {
    staticClass: "show-card-wrapper"
  }, _vm._l((_vm.carListComputed), function(item) {
    return _c('div', {
      staticClass: "car-item-container"
    }, [_c('a', {
      attrs: {
        "href": '/car/' + item.id
      }
    }, [_c("CarItem", {
      tag: "div",
      staticClass: "car-item",
      class: ['line-height-level-' + _vm.lineHeightLevel],
      attrs: {
        "data": item
      }
    })])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-more"
  }, [_c('a', {
    attrs: {
      "href": "/buy.htm",
      "target": "_blank"
    }
  }, [_vm._v("查看更多")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-de0e7fd6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/newcar/components/TemplateAmyOrBetty.vue
// module id = 110
// module chunks = 2 3 4 5